<div *ngIf="offer" class="answeredRFPsPreview">
  <div class="answeredRFPsPreview-pdf">
    <app-pdf-preview
      [offerTitle]="offer.title"
      [offerDocumentId]="offer.documentId"
      [offerRevision]="offer.revision"
      [pdfSrc]="pdfSrc"
      [isDealer]="isDealer"
      [offerPrice]="offer?.dealerBuyPrice"
      (pdfReady)="setPdfReady($event)"
    ></app-pdf-preview>
  </div>
  <div class="answeredRFPsPreview-aside">
    <div class="answeredRFPsPreview-body">
      <div *ngFor="let item of answeredRFPs" (click)="pdfReady && onItemSelected(item)" class="answeredRFPsPreview-item"
        [ngClass]="{'active': item == activeAnsweredRFP}">
        <div class="answeredRFPsPreviewItem-date">
          {{ item.date | date: 'dd. LLL yyyy':'de' }}
        </div>
        <div class="answeredRFPsPreviewItem-description">
          {{ item.title }}
        </div>
        <div class="answeredRFPsPreviewItem-modifier">
          {{'MODALS.ANSWERED_RFP_PREVIEW.MODIFIER' | translate}} {{ item.modifier }}
        </div>
        <div class="answeredRFPsPreviewItem-price">
          {{'MODALS.ANSWERED_RFP_PREVIEW.PRICE' | translate}} {{ item.totalPrice | currency: 'EUR': 'symbol' }}
        </div>
      </div>
    </div>
  </div>
</div>
